import { cXense, Gemius } from '@analytics/trackers';
import getMobileApplication from '@root/modules/analytics/utils/getMobileApplication';

interface Params {
  uid: string;
  cxid: string;
  ctx: any;
}

interface EventParams {
  gallery_id: string;
  gallery_image_id: string;
  gallery_image_title?: string;
  gallery_title?: string;
}

type CustomParameters = Record<string, unknown>;

const pageCustomParameters = (ctx: any) => {
  const { app, state } = ctx;

  const { id } = app.$channelConfig('settings');

  const customParameters: CustomParameters = {};
  customParameters.channel = id;

  customParameters.page_type = 'Article';
  customParameters.user_logged_in = state.piano.isLoggedIn ? 'yes' : 'no';
  customParameters.reg_user_dplus = state.piano.access.channelAccess;
  customParameters.ad_block = state.adForm.enableAdBlockLayer;

  const application = getMobileApplication(window.navigator.userAgent);
  if (application) {
    customParameters.browser_container = application;
  }

  if (state.piano.profile) {
    customParameters.userId = state.piano.profile?.uid;
  }

  return customParameters;
};

export default async function trackPageView(params: Params) {
  const { uid, cxid, ctx } = params;

  if (uid) {
    const gemiusTracker = new Gemius();
    await gemiusTracker.init({ uid });
    gemiusTracker.sendPageEvent();
  }

  if (cxid) {
    const cX = new cXense();
    await cX.init({ uid: cxid });

    // Send cX pageview event
    const { channelAccess } = ctx.$nuxt.$store.state.piano.access.channelAccess;

    const activeArticle = ctx.$nuxt.$store.getters['article/getActiveArticle'];

    const customParameters = pageCustomParameters(ctx.$nuxt.$store);
    const articleCustomParameters: CustomParameters = {
      channel: activeArticle.primaryCategory.channel.path ?? 'delfi',
      is_paid_article: activeArticle.content.paywall.enabled,
      is_paid_article_and_have_paid: activeArticle.content.paywall.enabled && channelAccess,
    };

    cX.pageView({}, { ...customParameters, ...articleCustomParameters });

    // Send cX custom event
    const eventParams: EventParams = {
      gallery_id: ctx.galleryId,
      gallery_image_id: ctx.activePicture?.id,
    };

    if (ctx.galleryTitle) {
      eventParams.gallery_title = ctx.galleryTitle;
    }

    if (ctx.activePicture?.metadata?.title) {
      eventParams.gallery_image_title = ctx.activePicture?.metadata?.title;
    }

    const eventOptions = {
      origin: 'lth-delfi',
      persistedQueryId: '60134f11dac530e2cd5c308a42f829d82289a3b8',
    };

    cX.sendEvent('gallery_view', eventParams, eventOptions);
  }
}
